export const clone = (element: Object | Array<any>) => {
    return JSON.parse(JSON.stringify(element));
};
